export { default as ProductsIndexPageMenu } from './ProductsIndexPageMenu';
